import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Capability } from 'console/device/device-capability';
import { CustomControlsBlock } from '../control-block/control-block';
export const CustomControlCard = memo(function CustomControlCard({ can_control, device_id, capabilities, custom_controls, }) {
    if (!(custom_controls != null &&
        custom_controls.length > 0 &&
        !capabilities.includes(Capability.has_car_sensors) &&
        !capabilities.includes(Capability.has_car_controls)))
        return null;
    return (_jsxs("div", { className: "ui-falarm-main-view-custom-controls ui-card", children: [_jsx("h1", { children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438 \u0441\u0442\u0430\u0442\u0443\u0441" }), _jsx(CustomControlsBlock, { device_id: device_id, can_control: can_control })] }));
});
